import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Form = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/series`} />

    <Route
      path={`${match.url}/detail/:id`}
      component={asyncComponent(() => import("./routes/serie-detail"))}
    />

    <Route
      path={`${match.url}/series`}
      component={asyncComponent(() => import("./routes/series"))}
    />

    <Route
      component={asyncComponent(() =>
        import("app/routes/extraPages/routes/404")
      )}
    />
  </Switch>
);

export default Form;



// WEBPACK FOOTER //
// ./app/routes/series/index.js